import { Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import analytics from "../util/analytics";
import { useAuth } from "../util/auth";

function AuthForm(props) {
  const auth = useAuth();
  const [pending, setPending] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const { handleSubmit, register, errors } = useForm();

  // Handle form submission
  const onSubmit = ({ email }) => {
    // Show pending indicator
    setPending(true);

    // Call submit handler for auth type
    auth
      .signinWithMagicLink(email)
      .then((user) => {
        setPending(false);
        setDisabled(true);
        props.onFormAlert({
          type: "success",
          message: "Check your email. We sent you a magic link to sign in!",
        });
        analytics.track("signin", { email, method: "email" });
      })
      .catch((error) => {
        setPending(false);
        // Show error alert message
        props.onFormAlert({
          type: "error",
          message: error.message,
        });
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        variant="outlined"
        type="email"
        label="Email"
        name="email"
        placeholder="user@example.com"
        error={!!errors.email}
        helperText={errors.email && errors.email.message}
        fullWidth
        disabled={disabled}
        inputRef={register({
          required: "Please enter your email",
        })}
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        color="primary"
        size="large"
        type="submit"
        disabled={pending || disabled}
        fullWidth
      >
        <span>{pending ? <CircularProgress size={28} /> : "Sign In"}</span>
      </Button>
    </form>
  );
}

export default AuthForm;
